<div class="container-fluid ">

  <div class="row  pt-2" style="display: flex;align-items: center;margin-bottom: 3%;">
    <div class="col-md-7 px-0 w-100">
      <p class="m-0 text-uppercase" style="font-size: 20px;color: #262756;font-weight: bold;">Compagnies</p>
      <small class="text-uppercase" style="font-size:15px;color: #959090;">Liste des compagnies </small>
    </div>
  </div>
  <div class="row rowposition  px-0">
    <div class="col-lg-12 col-xl-3 col-md-12 w-100 pl-0">
      <div>
      </div>
    </div>
    <div class="col-12 w-100 pl-0">
      <div class="row w-100 m-0 mb-2">
        <div class="col-2">
          <div class="export-icons d-flex mb-2">
            <div class="icn-sec">
              <!-- (click)="exportExcel(exportDirective, 'xlsx')" -->
              <img
                src="assets/newImages/excel-svg.svg" ngbTooltip="Expoter EXCEL"/>
            </div>
            <div class="icn-sec">
              <!-- (click)="exportTable()" -->
              <img
                src="assets/newImages/pdf-svg.svg" ngbTooltip="Expoter PDF"/>
            </div>
          </div>
        </div>
        <!-- <div class="col-2">
          <mat-form-field appearance="fill">
            <mat-label>Page</mat-label>
            <mat-select>
              <mat-option *ngFor="let item of collection" (click)="updateManualPage(item - 1)" value="{{item}}">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->
        <!-- <div class="col-2 ">
          <mat-form-field appearance="fill">
            <mat-label>Elément</mat-label>
            <mat-select [(ngModel)]="pageSize">
              <mat-option (click)="updateManualPage2(pageSize)" *ngFor="let pageSize of pageSizeOptions"
                [value]="pageSize">
                {{ pageSize }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->
        <div class="col-md-3">

          <mat-form-field class="w-100">
            <mat-label>Filtrer par compagnie</mat-label>
            <input matInput id="" (keyup)="applyFilter($event,1 )" placeholder="Filtrer par compagnie"
                   #input>
          </mat-form-field>


        </div>

        <div class="col-4  w-100" style="text-align: right;margin-top: -20px;">
          <img placement="left" ngbTooltip="Ajouter compagnie" style="width: 100px;"
               src="assets/icons/add-compagnie.svg"
               (click)="addCompanyPartner()"/>



        </div>
        <div class="col-1 w-100">
          <div
            *ngIf="listItems.length >1"
            (click)="supprimerCompany('moreThanOne',null,null)"
            class="mat-form-field"
            placement="left"
            ngbTooltip="Supprimer compagnies"
            style="
                  height: 55px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 63px;
                "
          >
            <mat-icon style="font-size: 25px; padding: 0 !important"
            >delete_forever</mat-icon
            >
          </div>
        </div>

        <div class="col-2 stylecompocompanypartner">
          <mat-form-field appearance="fill">
            <mat-label *ngIf="showtyppartLoad ==1" style="color: #ebeff2; font-weight: 500;">REVENDEURS</mat-label>
            <mat-select [(value)]="DefaultRev">
              <mat-option
                style="background-color: #262756; color: #ebeff2;"
                *ngFor="let type of compoTypeTable"
                (click)="changepartnetType(type)"
                [value]="type.type">
                {{ type.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row">

      </div>
      <div class="row rowposition pt-3 pl-0   w-100" style="margin-top: 2%;">
        <div class="col-12 col-md-12 w-100 mx-3" style="    padding: 0px; ">
          <!-- <div class="example-container-contact mat-elevation-z8 " >
            <ngx-spinner *ngIf="spinnerActivePartner != false" bdColor="rgba(100,112,124,0.56)" size="medium"
            color="#233547" type="ball-clip-rotate-multiple" [fullScreen]="false">
            <p style="color: white"> </p>
          </ngx-spinner>
          </div> -->


          <div class="col-12 col-md-12 w-100 pl-4">
            <div class="col-md-12">
              <p class="titleHeaderTable" style="font-size: 20px;"
                 *ngIf="showtyppart==1">LISTE DES COMPAGNIES (STG TELEMATICS)</p>
              <p class="titleHeaderTable" style="font-size: 20px;"
                 *ngIf="showtyppart==2">LISTE DES COMPAGNIES (ORANGE)</p>

            </div>


<!--            <div style="visibility: hidden; position: fixed;" [style.left]="menuTopLeftPosition.x"-->
<!--                 [style.top]="menuTopLeftPosition.y" [matMenuTriggerFor]="rightMenu"></div>-->

            <!-- standard material menu -->
<!--            <mat-menu #rightMenu="matMenu">-->
<!--              <ng-template matMenuContent let-item="item">-->

<!--                <button [ngClass]="{'disabledIcon':hiddenItemClick != '1'}" mat-menu-item-->
<!--                        (click)="updateCompanyPartner()">-->
<!--                  <img src="https://img.icons8.com/fluent/30/000000/client-company.png"/> Modifier-->
<!--                  Compagnie-->
<!--                </button>-->
<!--                <button [ngClass]="{'disabledIcon':hiddenItemClick == '0'}" mat-menu-item (click)="deleteCompany()"><img-->
<!--                  src="https://img.icons8.com/color/28/000000/delete-table.png"/> Supprimer-->
<!--                  Compagnie(s)-->
<!--                </button>-->
<!--                <button (click)="getItemsbyClick()" [ngClass]="{'disabledIcon':hiddenItemClick != '1'}" mat-menu-item>-->
<!--                  <img-->
<!--                    src="https://img.icons8.com/fluent/28/000000/new-company.png"/> Details de-->
<!--                  Compagnie-->
<!--                </button>-->
<!--                <mat-divider style="background-color: #ebeff2;" class="mx-2"></mat-divider>-->
<!--                <button mat-menu-item onclick=" getItemsVlue()" (click)="exportExcel('csv')"><img-->
<!--                  src="https://img.icons8.com/color/27/000000/export-csv.png"/>CSV-->
<!--                </button>-->
<!--                <button mat-menu-item (click)="exportExcel('xlsx')"><img-->
<!--                  src="https://img.icons8.com/color/27/000000/export-excel.png"/> xlsx-->
<!--                </button>-->
<!--                <button mat-menu-item (click)="exportExcel('json')"><img-->
<!--                  src="https://img.icons8.com/color/27/000000/json-download.png"/> JSON-->
<!--                </button>-->
<!--                <button mat-menu-item (click)="exportExcel('txt')"><img-->
<!--                  src="https://img.icons8.com/color/27/000000/rich-text-converter.png"/> TXT-->
<!--                </button>-->


<!--              </ng-template>-->
<!--            </mat-menu>-->
            <!-- <ngx-spinner *ngIf="partnercompanyrevendeur ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
              type="ball-clip-rotate-multiple" [fullScreen]="true">
              <p style="color: white"> </p>
            </ngx-spinner> -->
            <mat-accordion class="mb-4">

              <!-- <mat-expansion-panel class="mb-3" *ngFor="let companypartnerDataItem of companypartnerData; let i = index;"
                (opened)="setOpened(i)" (closed)="setClosed(i)">

                <mat-expansion-panel-header (click)="getItemData(companypartnerDataItem.id,companypartnerDataItem)">
                  <mat-panel-title style="    display: flex;
                  align-items: center;">

                    <img src="{{companypartnerDataItem.logo}}" class="logoSize" alt="">

                  </mat-panel-title>
                  <mat-panel-description style="    display: flex;
                  align-items: center;    justify-content: flex-end;">

                    {{companypartnerDataItem.name}} | {{ currentlyOpenedItemIndex === i ? 'Fermer' : 'Ouvrir' }}
                  </mat-panel-description>

                </mat-expansion-panel-header> -->


              <div class="row mb-3 px-3">


                <div class="col-md-7">

                </div>

                <div class="col-md-5 ">
                  <div class="row">
                    <!-- <div class="col-md-11">

                      <mat-form-field class="w-100">
                        <mat-label>Filtrer par compagnie</mat-label>
                        <input matInput id="" (keyup)="applyFilter($event,companypartnerDataItem )" placeholder="Filtrer par compagnie"
                          #input>
                      </mat-form-field>


                    </div> -->


                    <!-- <div type="butto," [matMenuTriggerFor]="menu1" class="col-md-1 mat-form-field hoverButton w-100 elhoo_dashboardMenu_IconSvgStyle" style="
              height: 51px;
              display: flex;
              justify-content: space-around;
              align-items: center; cursor: pointer;" placement="left" ngbTooltip="Exporter"  >



                      <i style="font-size:20px" class="fas fa-download"></i>
                      <mat-menu #menu1="matMenu" class="mr-3">
                        <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'csv')"> <img
                            src="https://img.icons8.com/color/27/000000/export-csv.png" />
                          CSV</button>
                        <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'xlsx')">
                          <img src="https://img.icons8.com/color/27/000000/export-excel.png" /> XLSX</button>


                        <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'json')"> <img
                            src="https://img.icons8.com/color/27/000000/json-download.png" />
                          JSON</button>



                        <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'txt')">
                          <img src="https://img.icons8.com/color/27/000000/rich-text-converter.png" />
                          TXT</button>


                        <button mat-menu-item (click)="exportDeviceTablePDF()">
                          <img src="https://img.icons8.com/color/27/000000/export-pdf.png" />
                          PDF</button>


                      </mat-menu>

                    </div> -->


                  </div>


                </div>


              </div>
              <div class="example-container  mat-elevation-z8 custmStyleheaderTable">


                <!-- Table  -->
                <ngx-spinner *ngIf="partnercompany ==true" bdColor="rgba(100,112,124,0.56)" size="medium"
                             color="#233547"
                             type="ball-clip-rotate-multiple" [fullScreen]="false">
                  <p style="color: white"></p>
                </ngx-spinner>

                <table #exportDirective="matTableExporter" matTableExporter mat-table [dataSource]="dataSource3"
                       class="mat-elevation-z8 w-100">

                  <!-- Checkbox Column -->
                  <ng-container matColumnDef="select">
                    <th style="    width: 47px;" mat-header-cell *matHeaderCellDef>


                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox disabled (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)"
                                    [aria-label]="checkboxLabel(row)">
                      </mat-checkbox>
                    </td>
                  </ng-container>

                  <!-- Position Column -->
                  <ng-container matColumnDef="Nom">
                    <th mat-header-cell *matHeaderCellDef> Nom</th>
                    <td mat-cell *matCellDef="let element"

                    >
                      <!-- class="colorTable" -->
                      {{element?.name}}</td>
                  </ng-container>

                  <!-- Name Column -->
                  <ng-container matColumnDef="Véhicules">
                    <th mat-header-cell *matHeaderCellDef> Véhicules</th>
                    <td mat-cell *matCellDef="let element"

                        style="padding-left: 30px !important;">
                      <!-- class="badge badge-info p-2" -->
                      <span
                      >{{element?.count_units}}  </span></td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="Personnes">
                    <th mat-header-cell *matHeaderCellDef> Personnes</th>
                    <td mat-cell *matCellDef="let element"

                        style="padding-left: 30px !important;">
                      <!-- class="badge badge-warning p-2" -->
                      <span
                      > {{element?.count_drivers}} </span></td>
                  </ng-container>

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="Utilisateurs">
                    <th mat-header-cell *matHeaderCellDef> Utilisateurs</th>
                    <td mat-cell *matCellDef="let element"

                        style="padding-left: 30px !important;">
                      <!-- class="badge badge-success p-2" -->
                      <span
                      >
                       {{element?.count_users}}</span>

                    </td>
                  </ng-container>

                  <ng-container matColumnDef="users">
                    <th mat-header-cell *matHeaderCellDef> Actions</th>
                    <td mat-cell *matCellDef="let row"

                    >

                      <!-- (click)="openDialogFileUpload()" -->
                      <img [ngClass]="{disable:listItems.length>1}"
                        ngbTooltip="Utilisateurs compagnie"
                        (click)='RedirectCompanyUser(row.id ,row.name ,compoTypeTableObjt.name,compoTypeTableObjt.logo)'
                        placement="left"
                        src="assets/icons/Utilisateurscompagnie.svg"
                      />
                      <!-- [ngClass]="{'disabledIcon':hiddenItemClick != '1'}" -->
                      <img [ngClass]="{disable:listItems.length>1}" placement="left" ngbTooltip="Modifier compagnie"
                           src="assets/icons/icon-modifier.svg"
                           (click)="updateCompanyPartner('oneItem',row)"
                      />


                      <a [ngClass]="{disable:listItems.length>1}"><img  placement="left" ngbTooltip="Supprimer compagnie"

                                                                       src="assets/icons/icon-delete.svg"
                                                                       (click)="supprimerCompany('oneItem',row.id,row.reseller_id)"/></a>

                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr  mat-row
                      *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
                      (click)="getgogo()">
                  </tr>
                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="12">
                      Aucune donnée correspondante à votre recherche

                    </td>
                  </tr>
                </table>


                <table style="display: none;visibility: hidden;" #exportDirective="matTableExporter" matTableExporter


                       id="ExampleTablecompany" mat-table [dataSource]="dataSource3" class="mat-elevation-z8 w-100">

                  <!-- Checkbox Column -->
                  <ng-container matColumnDef="select" style="display: none;visibility: hidden;">
                    <th style="    width: 47px;" mat-header-cell *matHeaderCellDef>


                    </th>
                    <td mat-cell *matCellDef="let row">

                    </td>
                  </ng-container>

                  <!-- Position Column -->
                  <ng-container matColumnDef="Nom">
                    <th mat-header-cell *matHeaderCellDef> Nom</th>
                    <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
                  </ng-container>

                  <!-- Name Column -->
                  <ng-container matColumnDef="Véhicules">
                    <th mat-header-cell *matHeaderCellDef> Véhicules</th>
                    <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
                  </ng-container>

                  <!-- Weight Column -->
                  <ng-container matColumnDef="Personnes">
                    <th mat-header-cell *matHeaderCellDef> Personnes</th>
                    <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
                  </ng-container>

                  <!-- Symbol Column -->
                  <ng-container matColumnDef="Utilisateurs">
                    <th mat-header-cell *matHeaderCellDef> Utilisateurs</th>
                    <td mat-cell *matCellDef="let element"
                    > <span
                      class="badge badge-success p-2">{{element?.name}}</span>

                    </td>
                  </ng-container>
                  <ng-container matColumnDef="users">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element"
                        style="padding-left: 30px !important;cursor: pointer;">

                      <img src="https://img.icons8.com/color/48/000000/group.png"/>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row
                      *matRowDef="let row; columns: displayedColumns;">
                  </tr>
                </table>
                <mat-paginator #paginator [pageSizeOptions]="[15, 30, 100]" (page)="pageChanged($event)" showFirstLastButtons></mat-paginator>

              </div>
              <!-- </mat-expansion-panel>-->
            </mat-accordion>


          </div>

        </div>
      </div>

    </div>
  </div>


  <!-- // -->
  <!-- style="display: none;" -->
  <div class="row   pt-2  " style="display: none;"
  >
    <div class="col-12 col-md-3 w-100 ">


      <div class="row   pb-3 test">

        <mat-form-field class="example-full-width w-100">
          <mat-label>Filtrer par Revendeur</mat-label>
          <input matInput (keyup)="getOeuvresByTaskId()" mdInput id="searchInput" #Input type="text">


        </mat-form-field>
      </div>


      <div class="row pt-2 pb-2" style="background: #323d415c;  border-radius: 6px">


<!--        <div class="col-6 col-md-3 w-100 positionIcons" placement="bottom" ngbTooltip="Afficher details">-->


<!--          <svg [ngClass]="{'disabledIcon':hiddenItemClick != '1'}" (click)="getItemsbyClick()" width="45px"-->
<!--               height="45px" id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512"-->
<!--               xmlns="http://www.w3.org/2000/svg">-->
<!--            <g>-->
<!--              <path d="m512 121.75v325.25c0 35.84-29.16 65-65 65h-382c-35.84 0-65-29.16-65-65v-325.25l256-56z"-->
<!--                    fill="#e7f2ff"/>-->
<!--              <path d="m512 121.75v325.25c0 35.84-29.16 65-65 65h-191v-446.25z" fill="#9dcfff"/>-->
<!--              <path d="m512 65v56.75h-512v-56.75c0-35.84 29.16-65 65-65h382c35.84 0 65 29.16 65 65z" fill="#00ddc0"/>-->
<!--              <path d="m512 65v56.75h-256v-121.75h191c35.84 0 65 29.16 65 65z" fill="#00ba9f"/>-->
<!--              <g>-->
<!--                <g>-->
<!--                  <g>-->
<!--                    <path-->
<!--                      d="m353.144 50.75h-270.47c-8.284 0-15 6.716-15 15s6.716 15 15 15h270.469c8.284 0 15-6.716 15-15s-6.715-15-14.999-15z"-->
<!--                      fill="#e7f2ff"/>-->
<!--                  </g>-->
<!--                </g>-->
<!--              </g>-->
<!--              <g>-->
<!--                <g fill="#9dcfff">-->
<!--                  <path-->
<!--                    d="m429.325 50.75h-15c-8.284 0-15 6.716-15 15s6.716 15 15 15h15c8.284 0 15-6.716 15-15s-6.716-15-15-15z"/>-->
<!--                  <path d="m368.14 65.75c0 8.28-6.71 15-15 15h-97.14v-30h97.14c8.29 0 15 6.72 15 15z"/>-->
<!--                </g>-->
<!--              </g>-->
<!--              <g>-->
<!--                <path-->
<!--                  d="m334.583 449.163h-157.166c-8.284 0-15-6.716-15-15s6.716-15 15-15h157.167c8.284 0 15 6.716 15 15s-6.717 15-15.001 15z"-->
<!--                  fill="#ffea80"/>-->
<!--              </g>-->
<!--              <g>-->
<!--                <path d="m349.58 434.16c0 8.29-6.71 15-15 15h-78.58v-30h78.58c8.29 0 15 6.72 15 15z" fill="#f3d332"/>-->
<!--              </g>-->
<!--              <path-->
<!--                d="m400.33 224.25v120.42c0 22.05-17.94 40-40 40h-36.33l-68-8.34-68 8.34h-36.33c-22.06 0-40-17.95-40-40v-120.42c0-22.06 17.94-40 40-40h208.66c22.06 0 40 17.94 40 40z"-->
<!--                fill="#00ddc0"/>-->
<!--              <path-->
<!--                d="m400.33 224.25v120.42c0 22.05-17.94 40-40 40h-36.33l-68-8.34v-192.08h104.33c22.06 0 40 17.94 40 40z"-->
<!--                fill="#00ba9f"/>-->
<!--              <path-->
<!--                d="m324 355.15v29.52h-136v-28.49c0-37.32 29.63-68.46 66.94-69.02 36.065-1.032 69.06 28.809 69.06 67.99z"-->
<!--                fill="#ff5e94"/>-->
<!--              <path d="m324 355.15v29.52h-68v-97.52c37.436 0 68 30.418 68 68z" fill="#ff3980"/>-->
<!--              <ellipse cx="256" cy="267.166" fill="#ffbda9" rx="53.999" ry="53.999"-->
<!--                       transform="matrix(.383 -.924 .924 .383 -88.796 401.439)"/>-->
<!--              <path-->
<!--                d="m310 267.17c0 13.36-4.88 25.6-12.93 35.03-9.92 11.6-24.65 18.97-41.07 18.97v-108c29.78 0 54 24.22 54 54z"-->
<!--                fill="#ffa68c"/>-->
<!--              <path-->
<!--                d="m442.298 408.369-10.421-10.421 9.116-9.116c8.162-8.162 4.405-22.114-6.725-25.095l-53.883-14.438c-5.177-1.387-10.7.093-14.488 3.882-3.789 3.789-5.27 9.313-3.883 14.489l14.438 53.883c3.005 11.207 16.983 14.838 25.096 6.724l9.116-9.116 10.421 10.421c5.857 5.858 15.355 5.859 21.213 0 5.858-5.858 5.858-15.355 0-21.213z"-->
<!--                fill="#5a5a5a"/>-->
<!--              <path-->
<!--                d="m440.997 388.833-9.115 9.115 10.416 10.416c5.862 5.862 5.855 15.358 0 21.213l-76.396-76.396c3.79-3.79 9.313-5.268 14.489-3.882l53.882 14.439c11.145 2.984 14.872 16.947 6.724 25.095z"-->
<!--                fill="#444"/>-->
<!--            </g>-->
<!--          </svg>-->

<!--        </div>-->
<!--        <div class="col-6 col-md-3 w-100 positionIcons" placement="bottom" ngbTooltip="Modifier compagnie">-->

<!--          <svg [ngClass]="{'disabledIcon':hiddenItemClick != '1'}" (click)="updateCompanyPartner()" width="45px"-->
<!--               height="45px" id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512"-->
<!--               xmlns="http://www.w3.org/2000/svg">-->
<!--            <g>-->
<!--              <path-->
<!--                d="m427.78 482h-382.614c-8.362 0-15.166-6.804-15.166-15.166v-.239c0-8.362 6.804-15.165 15.166-15.165h176.478c24.904 0 45.165-20.262 45.165-45.166s-20.261-45.165-45.165-45.165h-94.074c-8.284 0-15 6.716-15 15s6.716 15 15 15h94.073c8.362 0 15.165 6.803 15.165 15.165s-6.803 15.166-15.165 15.166h-176.477c-24.904 0-45.166 20.26-45.166 45.165v.239c0 24.904 20.262 45.166 45.166 45.166h382.614c8.284 0 15-6.716 15-15s-6.716-15-15-15z"-->
<!--                fill="#3ba9ff"/>-->
<!--              <path-->
<!--                d="m485.52 404.5-44.04 98.62c-2.42 5.4-7.78 8.88-13.7 8.88s-11.28-3.48-13.7-8.88l-44.04-98.62 57.74-17z"-->
<!--                fill="#3ba9ff"/>-->
<!--              <path d="m485.516 404.5-44.04 98.62c-2.42 5.4-7.78 8.88-13.7 8.88v-107.5z" fill="#0081ff"/>-->
<!--              <path d="m512 96.32v245.68l-84.22 21.259-84.22-21.259v-245.68l84.216-16.653z" fill="#ffea80"/>-->
<!--              <path d="m427.776 96.32h84.22v245.68h-84.22z" fill="#f3d332"/>-->
<!--              <path d="m512 342c0 2.08-.43 4.17-1.3 6.12l-25.18 56.38h-115.48l-25.18-56.38c-.87-1.95-1.3-4.04-1.3-6.12z"-->
<!--                    fill="#e7f2ff"/>-->
<!--              <path d="m512 342c0 2.08-.43 4.17-1.3 6.12l-25.18 56.38h-57.74v-62.5z" fill="#9dcfff"/>-->
<!--              <path d="m512 84.21v12.11h-168.44v-12.11c0-46.43 37.78-84.21 84.22-84.21s84.22 37.78 84.22 84.21z"-->
<!--                    fill="#ff5e94"/>-->
<!--              <path d="m511.996 84.21v12.11h-84.22v-96.32c46.44 0 84.22 37.78 84.22 84.21z" fill="#ff3980"/>-->
<!--            </g>-->
<!--          </svg>-->


<!--        </div>-->
<!--        <div (click)="addCompanyPartner()" class="col-6 col-md-3 w-100 positionIcons" placement="bottom"-->
<!--             ngbTooltip="Ajouter compagnie">-->

<!--          <img src="https://img.icons8.com/fluent/50/000000/company.png"/>-->

<!--        </div>-->
<!--        <div class="col-6 col-md-3 w-100 positionIcons" placement="bottom" ngbTooltip="Supprimer Compagnie">-->

<!--          <svg (click)="supprimerCompany()" [ngClass]="{'disabledIcon':hiddenItemClick == '0'}" width="45px"-->
<!--               height="45px" id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512"-->
<!--               xmlns="http://www.w3.org/2000/svg">-->
<!--            <g>-->
<!--              <g>-->
<!--                <path-->
<!--                  d="m415.158 85.758c-.268.087-93.932 27.686-94.198 27.777-10.041 3.493-16.788 12.983-16.788 23.614v42.223c0 8.285 6.716 15.001 15.001 15.001h114.008c8.285 0 15.001-6.716 15.001-15.001v-69.935c0-17.077-16.817-29.172-33.024-23.679z"-->
<!--                  fill="#ff5e94"/>-->
<!--                <path-->
<!--                  d="m160.161 164.371v282.624c0 35.844 29.161 65.005 65.005 65.005h158.012c35.844 0 65.005-29.161 65.005-65.005 0-15.734 0-274.731 0-282.624z"-->
<!--                  fill="#9dcfff"/>-->
<!--                <path d="m304.172 164.371v347.629h79.006c35.843 0 65.005-29.162 65.005-65.005v-282.624z"-->
<!--                      fill="#72bbff"/>-->
<!--                <g fill="#5a5a5a">-->
<!--                  <path-->
<!--                    d="m237.431 233.376c-8.285 0-15.001 6.716-15.001 15.001v179.616c0 8.285 6.716 15.001 15.001 15.001s15.001-6.716 15.001-15.001v-179.616c0-8.285-6.717-15.001-15.001-15.001z"/>-->
<!--                  <path-->
<!--                    d="m304.171 233.376c-8.285 0-15.001 6.716-15.001 15.001v179.616c0 8.285 6.716 15.001 15.001 15.001s15.001-6.716 15.001-15.001v-179.616c0-8.285-6.716-15.001-15.001-15.001z"/>-->
<!--                </g>-->
<!--                <g fill="#444">-->
<!--                  <path-->
<!--                    d="m319.172 248.381v179.613c0 8.281-6.72 15.001-15.001 15.001v-209.615c8.281 0 15.001 6.71 15.001 15.001z"/>-->
<!--                  <path-->
<!--                    d="m370.912 233.376c-8.285 0-15.001 6.716-15.001 15.001v179.616c0 8.285 6.716 15.001 15.001 15.001s15.001-6.716 15.001-15.001v-179.616c0-8.285-6.716-15.001-15.001-15.001z"/>-->
<!--                </g>-->
<!--                <path-->
<!--                  d="m192.17 18.07s0 0-.01 0c-15.336-9.588-36.016-7.793-49.46 5.65v.01l-27.58 27.57-27.58 27.58c-15.6 15.6-15.6 40.98 0 56.57l14.15 14.15 20.31-2.1.9-19.12-14.14-14.14c-3.9-3.9-3.9-10.25 0-14.14l27.58-27.58 27.57-27.58h.01c3.689-3.689 10.025-4.116 14.13-.01l14.15 14.15 18.55-3.08 2.67-18.13c-14.806-14.806-16.41-16.818-21.25-19.8z"-->
<!--                  fill="#5a5a5a"/>-->
<!--                <path-->
<!--                  d="m192.17 18.07s0 0-.01 0c-15.297-9.564-35.968-7.831-49.46 5.66l-27.58 27.57 21.22 21.22 27.58-27.58c3.686-3.686 10.017-4.124 14.13-.01l14.15 14.15 21.22-21.21c-15.291-15.291-16.162-16.574-21.25-19.8z"-->
<!--                  fill="#444"/>-->
<!--                <path-->
<!--                  d="m317.418 37.108-26.872-26.872c-13.647-13.647-35.853-13.647-49.501 0l-166.992 166.991c-13.647 13.647-13.647 35.853 0 49.501l26.872 26.872c5.857 5.858 15.356 5.859 21.214 0l195.279-195.278c5.858-5.858 5.858-15.356 0-21.214z"-->
<!--                  fill="#3ba9ff"/>-->
<!--                <path-->
<!--                  d="m290.545 10.236 26.872 26.872c5.855 5.855 5.862 15.352 0 21.215l-97.637 97.637-62.23-62.23 83.494-83.494c13.648-13.648 35.853-13.648 49.501 0z"-->
<!--                  fill="#0081ff"/>-->
<!--              </g>-->
<!--            </g>-->
<!--          </svg>-->


<!--        </div>  -->

      </div>


    </div>


    <div class="col-12 col-md-9 w-100 pl-4">


<!--      <div style="visibility: hidden; position: fixed;" [style.left]="menuTopLeftPosition.x"-->
<!--           [style.top]="menuTopLeftPosition.y" [matMenuTriggerFor]="rightMenu"></div>-->

      <!-- standard material menu -->
<!--      <mat-menu #rightMenu="matMenu">-->
<!--        <ng-template matMenuContent let-item="item">-->

<!--          <button [ngClass]="{'disabledIcon':hiddenItemClick != '1'}" mat-menu-item (click)="updateCompanyPartner()">-->
<!--            <img src="https://img.icons8.com/fluent/30/000000/client-company.png"/> Modifier-->
<!--            Compagnie-->
<!--          </button>-->
<!--          <button [ngClass]="{'disabledIcon':hiddenItemClick == '0'}" mat-menu-item (click)="deleteCompany()"><img-->
<!--            src="https://img.icons8.com/color/28/000000/delete-table.png"/> Supprimer-->
<!--            Compagnie(s)-->
<!--          </button>-->
<!--          <button (click)="getItemsbyClick()" [ngClass]="{'disabledIcon':hiddenItemClick != '1'}" mat-menu-item><img-->
<!--            src="https://img.icons8.com/fluent/28/000000/new-company.png"/> Details de-->
<!--            Compagnie-->
<!--          </button>-->
<!--          <mat-divider style="background-color: #ebeff2;" class="mx-2"></mat-divider>-->
<!--          <button mat-menu-item onclick=" getItemsVlue()" (click)="exportExcel('csv')"><img-->
<!--            src="https://img.icons8.com/color/27/000000/export-csv.png"/>CSV-->
<!--          </button>-->
<!--          <button mat-menu-item (click)="exportExcel('xlsx')"><img-->
<!--            src="https://img.icons8.com/color/27/000000/export-excel.png"/> xlsx-->
<!--          </button>-->
<!--          <button mat-menu-item (click)="exportExcel('json')"><img-->
<!--            src="https://img.icons8.com/color/27/000000/json-download.png"/> JSON-->
<!--          </button>-->
<!--          <button mat-menu-item (click)="exportExcel('txt')"><img-->
<!--            src="https://img.icons8.com/color/27/000000/rich-text-converter.png"/> TXT-->
<!--          </button>-->


<!--        </ng-template>-->
<!--      </mat-menu>-->
      <ngx-spinner *ngIf="partnercompanyrevendeur ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
                   type="ball-clip-rotate-multiple" [fullScreen]="true">
        <p style="color: white"></p>
      </ngx-spinner>
      <mat-accordion class="mb-4">

        <mat-expansion-panel class="mb-3" *ngFor="let companypartnerDataItem of companypartnerData; let i = index;"
                             (opened)="setOpened(i)" (closed)="setClosed(i)">

          <mat-expansion-panel-header (click)="getItemData(companypartnerDataItem.id,companypartnerDataItem)">
            <mat-panel-title style="    display: flex;
            align-items: center;">

              <img src="{{companypartnerDataItem.logo}}" class="logoSize" alt="">

            </mat-panel-title>
            <mat-panel-description style="    display: flex;
            align-items: center;    justify-content: flex-end;">

              {{companypartnerDataItem.name}} | {{ currentlyOpenedItemIndex === i ? 'Fermer' : 'Ouvrir' }}
            </mat-panel-description>

          </mat-expansion-panel-header>


          <div class="row mb-3 px-3">


            <div class="col-md-7">

            </div>

            <div class="col-md-5 ">
              <div class="row">
                <div class="col-md-11">

                  <mat-form-field class="w-100">
                    <mat-label>Filtrer par compagnie</mat-label>
                    <input matInput id="" (keyup)="applyFilter($event,companypartnerDataItem )"
                           placeholder="Filtrer par compagnie"
                           #input>
                  </mat-form-field>


                </div>


                <div type="butto," [matMenuTriggerFor]="menu1"
                     class="col-md-1 mat-form-field hoverButton w-100 elhoo_dashboardMenu_IconSvgStyle" style="
          height: 51px;
          display: flex;
          justify-content: space-around;
          align-items: center; cursor: pointer;" placement="left" ngbTooltip="Exporter">


                  <i style="font-size:20px" class="fas fa-download"></i>
                  <mat-menu #menu1="matMenu" class="mr-3">
                    <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'csv')"><img
                      src="https://img.icons8.com/color/27/000000/export-csv.png"/>
                      CSV
                    </button>
                    <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'xlsx')">
                      <img src="https://img.icons8.com/color/27/000000/export-excel.png"/> XLSX
                    </button>


                    <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'json')"><img
                      src="https://img.icons8.com/color/27/000000/json-download.png"/>
                      JSON
                    </button>


                    <button mat-menu-item (click)="exportDeviceTable(exportDirective, 'txt')">
                      <img src="https://img.icons8.com/color/27/000000/rich-text-converter.png"/>
                      TXT
                    </button>


                    <button mat-menu-item (click)="exportDeviceTablePDF()">
                      <img src="https://img.icons8.com/color/27/000000/export-pdf.png"/>
                      PDF
                    </button>


                  </mat-menu>

                </div>


              </div>


            </div>


          </div>
          <div class="example-container  mat-elevation-z8">


            <!-- Table  -->
            <ngx-spinner *ngIf="partnercompany ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
                         type="ball-clip-rotate-multiple" [fullScreen]="false">
              <p style="color: white"></p>
            </ngx-spinner>

            <table #exportDirective="matTableExporter" matTableExporter mat-table [dataSource]="dataSource3"
                   class="mat-elevation-z8 w-100">

              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th style="    width: 47px;" mat-header-cell *matHeaderCellDef>


                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox disabled (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                                [aria-label]="checkboxLabel(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <!-- Position Column -->
              <ng-container matColumnDef="Nom">
                <th mat-header-cell *matHeaderCellDef> Nom</th>
                <td mat-cell *matCellDef="let element"><b class="colorTable">{{element?.name}}</b></td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="Véhicules">
                <th mat-header-cell *matHeaderCellDef> Véhicules</th>
                <td mat-cell *matCellDef="let element" style="    padding-left: 30px !important;"><span
                  class="badge badge-info p-2">{{element?.count_units}}  </span></td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="Personnes">
                <th mat-header-cell *matHeaderCellDef> Personnes</th>
                <td mat-cell *matCellDef="let element" style="    padding-left: 30px !important;"><span
                  class="badge badge-warning p-2"> {{element?.count_drivers}} </span></td>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="Utilisateurs">
                <th mat-header-cell *matHeaderCellDef> Utilisateurs</th>
                <td mat-cell *matCellDef="let element" style="    padding-left: 30px !important;">
                  <span class="badge badge-success p-2">{{element?.count_users}}</span>

                </td>
              </ng-container>

              <ng-container matColumnDef="users">
                <th mat-header-cell *matHeaderCellDef> Actions</th>
                <td
                  (click)='RedirectCompanyUser(element?.id ,element?.name ,companypartnerDataItem.name,companypartnerDataItem.logo)'
                  mat-cell *matCellDef="let element"
                  style="padding-left: 8px !important;cursor: pointer;">

                  <img placement="left" ngbTooltip="Utilisateurs compagnie {{companypartnerDataItem.name}}"
                       src="https://img.icons8.com/ultraviolet/40/000000/select-users.png"/>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr  mat-row
                  *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)" (click)="getgogo()">
              </tr>

<!--              <tr (contextmenu)="onRightClick($event,exportDirective, row)" mat-row-->
<!--                  *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)" (click)="getgogo()">-->
<!--              </tr>-->
              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="12">
                  Aucune donnée correspondante à votre recherche

                </td>
              </tr>
            </table>


            <table style="display: none;visibility: hidden;" #exportDirective="matTableExporter" matTableExporter
                   id="ExampleTablecompany" mat-table [dataSource]="dataSource3" class="mat-elevation-z8 w-100">

              <!-- Checkbox Column -->
              <ng-container matColumnDef="select" style="display: none;visibility: hidden;">
                <th style="    width: 47px;" mat-header-cell *matHeaderCellDef>


                </th>
                <td mat-cell *matCellDef="let row">

                </td>
              </ng-container>

              <!-- Position Column -->
              <ng-container matColumnDef="Nom">
                <th mat-header-cell *matHeaderCellDef> Nom</th>
                <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="Véhicules">
                <th mat-header-cell *matHeaderCellDef> Véhicules</th>
                <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="Personnes">
                <th mat-header-cell *matHeaderCellDef> Personnes</th>
                <td mat-cell *matCellDef="let element"> {{element?.name}} </td>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="Utilisateurs">
                <th mat-header-cell *matHeaderCellDef> Utilisateurs</th>
                <td mat-cell *matCellDef="let element"
                > <span
                  class="badge badge-success p-2">{{element?.name}}</span>

                </td>
              </ng-container>
              <ng-container matColumnDef="users">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element"
                    style="padding-left: 30px !important;cursor: pointer;">

                  <img src="https://img.icons8.com/color/48/000000/group.png"/>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row
                  *matRowDef="let row; columns: displayedColumns;">
              </tr>
            </table>
            <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20]" (page)="pageChanged($event)" showFirstLastButtons></mat-paginator>

          </div>
        </mat-expansion-panel>
      </mat-accordion>


    </div>

  </div>

</div>
